export default {"src":"/_next/static/media/coin_plant.c0029ae5.svg","height":170,"width":170};